import { useContext } from 'react';

import { HistogramInteractionsContext } from '../contexts/HistogramInteractionsContext.js';

export const useHistogramInteractions = () =>
  useContext(HistogramInteractionsContext);
